import { InputGroup } from 'react-bootstrap';
import styled from 'styled-components';

import { min } from '../../utils/breakpoints';

const LabelInputGroup = styled(InputGroup)`
  .form-control {
    border-right: none;
    border-color: ${(props) => props.theme.colors.light};

    &.error {
      border-color: ${(props) => props.theme.colors.error};
    }
  }
  .input-group-text {
    background: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
    border-color: ${(props) => props.theme.colors.light};
    padding: 2px 0;

    .divider {
      border-left: 1px solid ${(props) => props.theme.colors.light};
      padding: 2px 12px;
      font-size: 14px;

      ${min.sm} {
        font-size: 16px;
      }
    }

    &.error {
      border-color: ${(props) => props.theme.colors.error};

      .divider {
        border-color: ${(props) => props.theme.colors.error};
      }
    }
  }
`;

export default LabelInputGroup;
